import { create } from 'zustand';

import { IwQuestionsState, QuestionDataMap, QuestionsStep } from '@/entities/interwills';

import { nextStep } from '../helpers';

type IwQuestionsStore = IwQuestionsState & {
  questionNext: () => void;
  setQuestionStep: (step: QuestionsStep) => void;
  setQuestionSubStep: (step: number) => void;
  setStepData: <TStep extends QuestionsStep>(step: TStep, data: QuestionDataMap[TStep]) => void;
  reset: () => void;
  extractStateForCollection: () => IwQuestionsState;
};

const getInitialState = (): IwQuestionsState => ({
  questionStep: 1,
  questionSteps: 10,
  questionSubStep: 0,
  data: {},
});

export const useIwQuestionsStore = create<IwQuestionsStore>((set, get) => ({
  ...getInitialState(),

  questionNext: () => set({ questionStep: nextStep(get().questionStep) }),
  setQuestionStep: (questionStep) => set({ questionStep }),
  setQuestionSubStep: (questionSubStep) => set({ questionSubStep }),
  setStepData: (step, stepData) => {
    const newData = { ...get().data };

    newData[step] = stepData;

    set({ data: newData });
  },
  reset: () => set({ ...getInitialState() }),

  extractStateForCollection: () => ({
    questionStep: get().questionStep,
    questionSteps: get().questionSteps,
    questionSubStep: get().questionSubStep,
    data: get().data,
  }),
}));
